import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _6mpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"6mp"}/>
}
